import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=437e7f49&scoped=true&"
import script from "./confirm.vue?vue&type=script&lang=js&"
export * from "./confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437e7f49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('437e7f49')) {
      api.createRecord('437e7f49', component.options)
    } else {
      api.reload('437e7f49', component.options)
    }
    module.hot.accept("./confirm.vue?vue&type=template&id=437e7f49&scoped=true&", function () {
      api.rerender('437e7f49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/core/confirm.vue"
export default component.exports